import { axiosInstance } from '../axios-instance';
import { IChangeLanguageParams, IChangePasswordParams, IMyInfo } from './types';

export const getMyInfo = async (): Promise<IMyInfo> => {
  return axiosInstance.get('/users/my-info');
};

export const updatePassword = async (
  params: IChangePasswordParams
): Promise<void> => {
  return axiosInstance.put('/users/my-info/change-password', params);
};

export const changeLanguage = async (
  params: IChangeLanguageParams
): Promise<void> => {
  return axiosInstance.put('/users/my-info/change-language', params);
};
